import 'src/pages/userComponents/userStyle.scss';
import 'antd/dist/antd.css';
import { Form } from 'antd';
import React from 'react';
import TextComponent from '@sharedComponent/typography/TextComponent';
import { useHistory } from 'react-router-dom';

const SignaturePresentational = ({ }) => {
	const history = useHistory();
	return (
		<div>
			<div className="headercontainer">
				<text style={{ width: '350px' }}>
					<TextComponent className="heading_3_text"> Are You The Authorised Signatory Of The Company?</TextComponent>
				</text>

				<TextComponent className="text-lg">Only the authorised signatory of your company can sign the payroll agreement.</TextComponent>
				<TextComponent className="text-lg">
					Know your authorised signatory by checking your trade license or power of attorney/memorandum of association.
				</TextComponent>
			</div>
			<div className="signaturecon">
				<Form.Item name="No" initialValue={'some Name'} style={{ margin: ' 1%', width: '50%' }}>
					<button className="ynbtn" onClick={() => history.push('/user/signature/3')}>No</button>
				</Form.Item>
				<Form.Item name="Yes" initialValue={'some Name'} style={{ margin: ' 1%', width: '50%' }}>
					<button className="ynbtn" onClick={() => {
						history.push('/user/signature/2');
					}}>Yes</button>
				</Form.Item>
			</div>

		</div>
	);
};
export default SignaturePresentational;
